import React from 'react'
import { Event } from '@/types'
import Link from 'next/link'
import { RiTwitterXFill } from 'react-icons/ri'
import { MdOutlineMail } from 'react-icons/md'
import {
  FaFacebookSquare,
  FaInstagram,
  FaExternalLinkAlt,
  FaTelegram,
} from 'react-icons/fa'

const SocialMedia = ({ event }: { event: Event }) => {
  return (
    <div className="flex items-end justify-start gap-4">
      {event?.social_media_links &&
        event?.social_media_links
          .filter((social_media) => social_media.link) // Filter out items without links
          .map((social_media, index) => {
            // Check if the link is an email address
            const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
              social_media.link ?? ''
            )

            let iconComponent = null
            if (['x-company', 'twitter'].includes(social_media.icon ?? '')) {
              iconComponent = <RiTwitterXFill size="24" color="white" />
            } else if (social_media.icon === 'instagram') {
              iconComponent = <FaInstagram size="24" color="white" />
            } else if (social_media.icon === 'facebook') {
              iconComponent = <FaFacebookSquare size="24" color="white" />
            } else if (social_media.icon === 'telegram') {
              iconComponent = <FaTelegram size="24" color="white" />
            } else if (social_media.icon === 'mail' || isEmail) {
              iconComponent = <MdOutlineMail size="24" color="white" />
            } else {
              // Use external link icon for other/unknown social media platforms
              iconComponent = <FaExternalLinkAlt size="24" color="white" />
            }

            // Format the href based on whether it's an email or URL
            let href: string
            if (isEmail) {
              href = `mailto:${social_media.link}`
            } else {
              // Ensure the URL has a protocol for web links
              href = (social_media.link ?? '').match(/^https?:\/\//)
                ? (social_media.link ?? '')
                : `https://${social_media.link}`
            }

            return (
              <a
                key={index}
                href={isEmail ? '#' : href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 bg-gray-800 rounded-full flex items-center justify-center"
                onClick={
                  isEmail
                    ? (e) => {
                        e.preventDefault()
                        const mailtoLink = `mailto:${social_media.link}`
                        try {
                          window.location.href = mailtoLink
                        } catch {
                          navigator.clipboard.writeText(`${social_media.link}`)
                          alert(
                            `Could not open email app. Copied: ${social_media.link}`
                          )
                        }
                      }
                    : undefined
                }
              >
                {iconComponent}
              </a>
            )

            // return (
            //   <Link
            //     key={index}
            //     href={href}
            //     target="_blank"
            //     className="w-11 h-11 bg-gray-800 rounded-full flex items-center justify-center"
            //   >
            //     {iconComponent}
            //   </Link>
            // )
          })}
    </div>
  )
}

export default SocialMedia
